module.exports = __webpack_public_path__ + "img/eye.51c9a71f.svg";